import { environment } from '../../environments/environment';

const baseUrl: string = environment.HbaseUrl + 'api/';
const assetsUrl: string = environment.assetsUrl;

const newsUrl: string = 'assets/api/newsCenter';
const aboutUrl: string = 'assets/api/about';
const productsUrl: string = 'assets/api/products';
const successUrl: string = 'assets/api/success';
const cooperationUrl: string = 'assets/api/cooperation';

export const config: any = {
	// ** web 1.0
	baseUrl,
	Memorabilia: baseUrl + 'Memorabilia',
	News: baseUrl + 'News',

	// ** web 2.0
	about: assetsUrl + aboutUrl,
	news: assetsUrl + newsUrl,
	products: assetsUrl + productsUrl,
	success: assetsUrl + successUrl,
	cooperation: assetsUrl + cooperationUrl,
};
